import Vue from 'vue';
import Router from 'vue-router';
import App from './App';

Vue.use(Router)

const createRouter = () => new Router({
    mode: 'history',
    routes: [{
        name: 'cheese',
        path: '/cheese',
        component: App
    },{
        name: 'edu_cheese',
        path: '/',
        component: App
    }],
})

export default createRouter